import { GetPlansResponse } from "../interfaces/api/get-plans";

export const planMapper = {
  mapResponseToPlans(response: GetPlansResponse): any[] {
    return response.payload.plans;
  },
};
